import React from "react";

import { useContext } from "../Context";

export default function Index() {
  const { state } = useContext();

  return (
    <dl className="dl-horizontal font-14">
      <dt>Bank Name</dt>
      <dd>{state.paymentMethod.attributes.options.bank_name}</dd>
      <dt>Account Number</dt>
      <dd>*******{state.paymentMethod.attributes.options.last4}</dd>
    </dl>
  );
}
